import { FilterDropdownProps } from "antd/es/table/interface";
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useRef,
  useState,
} from "react";

const TableSearchContext = createContext({} as TableSearchContextProps);

interface TableSearchContextProps {
  handleReset: (clearFilters: () => void) => void;
  handleSearch: (
    selectedKeys: string,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: any
  ) => void;
  handleResetFilters: () => void;
  searchText: string;
  searchedColumn: string;
  searchedInput: any;
  currentPage: number;
  pageSize: number;
  setPageSize: Dispatch<SetStateAction<number>>;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  setSearchText: Dispatch<SetStateAction<string>>;
  setSearchedColumn: Dispatch<SetStateAction<string>>;
  specificFilter: string;
  setSpecificFilter: Dispatch<SetStateAction<string>>;
}

export const TableSearchProvider = ({ children }: { children: ReactNode }) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [specificFilter, setSpecificFilter] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const searchedInput = useRef(null);

  const handleSearch = (
    text: string,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: any
  ) => {
    setSearchText(text);
    setSearchedColumn(dataIndex);
    confirm();
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };


  const handleResetFilters = () => {
    setSearchText("");
    setSearchedColumn("");
    setSpecificFilter("");
    setCurrentPage(1);
    setPageSize(10);
  };

  return (
    <TableSearchContext.Provider
      value={{
        handleReset,
        handleSearch,
        searchText,
        searchedColumn,
        searchedInput,
        setSearchText,
        setSearchedColumn,
        setCurrentPage,
        setPageSize,
        currentPage,
        pageSize,
        handleResetFilters,
        specificFilter,
        setSpecificFilter
      }}
    >
      {children}
    </TableSearchContext.Provider>
  );
};

export const useTableSearch = () => useContext(TableSearchContext);
